import { useRef } from "react";

import "./textbox.scss";

type TextBoxProps = {
  placeholder?: string;
  value: string;
  onChange: (string: string) => void;
  disabled?: boolean;
  maxLength?: number;
};

export const TextArea: React.FC<TextBoxProps> = ({
  value,
  placeholder,
  onChange,
  disabled,
  maxLength,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const resolvedMaxLength = maxLength ?? 800;

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(event.target.value);

    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height =
        textareaRef.current.scrollHeight + "px";
    }
  };

  return (
    <div className="input-character-counter-container">
      <textarea
        // style={disabled ? { backgroundColor: "lightgray" } : {}}
        disabled={disabled}
        maxLength={resolvedMaxLength}
        ref={textareaRef}
        className="text-area"
        placeholder={placeholder}
        value={value}
        onChange={handleInputChange}
      />
      <span className="input-character-counter">
        {value.length}/{resolvedMaxLength}
      </span>
    </div>
  );
};
